<template>
  <div class="generic-summary-list">
    <div class="generic-summary-header">
      <div class="generic-summary-title">{{title}}</div>
      <Button v-if="buttonText" class="link" @click="actionEvent">{{buttonText}}</Button>
    </div>
    <div>
      <PaymentSummaryItem v-for="(dataKey, i) in Object.keys(data)" :key="i"
        :loading="loading"
        :itemName="dataKey"
        :value="data[dataKey]"/>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import Button from '@/components/ui/AppButton.vue';
import PaymentSummaryItem from './PaymentSummaryItem.vue';

export default {
  name: 'generic-summary-list',
  components: { PaymentSummaryItem, Button },
  mixins: [StringMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
    title: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    event: {
      type: String,
    },
  },
  methods: {
    actionEvent(value) {
      this.$emit(this.event, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.generic-summary-list {
  padding-top: 36px;
}
.generic-summary-title {
  @extend .h3;
  @extend .gray-600;
}
.generic-summary-header {
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.link {
  @extend .small-regular;
  display: flex;
  padding: 0;
}
</style>
